import { render, staticRenderFns } from "./ImoFalFormsGeneralGrid.vue?vue&type=template&id=0c6dc6e0"
import script from "./ImoFalFormsGeneralGrid.vue?vue&type=script&lang=js"
export * from "./ImoFalFormsGeneralGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports